export const SET_TOKEN = 'token//SET_TOKEN'

interface TokenState {
  data: string
}

interface TokenAction {
  type: string
  payload: string
}

export function setToken(data: string): TokenAction {
  return {
    type: SET_TOKEN,
    payload: data,
  }
}

export function getToken(store: any): string | null | undefined {
  return store.token?.data
}

const initialState: TokenState = {
  data: '',
}

export default function tokenReducer(
  state: TokenState = initialState,
  action: TokenAction,
): TokenState {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        data: action.payload,
      }

    default:
      return state
  }
}
